<template>
  <div class="container">
    <div class="container__inner concept">
      <p class="concept__title">新ふつうデザイン</p>
      <p class="concept__text">人々にとってのふつう
        <br>ふつうにできることを
        <br>ふつうにできるようにする
        <br>気がついたらふつうになっている
      </p>
      <p class="concept__text">私たちは今もこれからも
        <br>「ふつう」をデザインしていきます
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'o-Header'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.container {
  margin: 0;
  padding: 120px 0;
  background: rgba(238, 220, 68, 0.1);
  box-shadow: inset 0px 10px 8px -10px rgba(0, 0, 0, 0.4),
    inset 0px -10px 8px -10px rgba(0, 0, 0, 0.4);
  @media screen and (min-width: 412px) and (max-width: 768px) {
    margin: 0;
    padding: 60px 0;
  }
  @media screen and (max-width: 411px) {
    margin: 0;
    padding: 60px 0;
  }
}

.concept {
  display: flex;
  flex-direction: column;
  justify-content: center;
  writing-mode: vertical-rl;
  letter-spacing: 3px;
  line-height: 2.4;
  font-family: fot-tsukuardgothic-std;
  font-weight: bold;
  &__title {
    font-size: 32px;
    &:first-child {
      margin-left: 2em;
    }
  }
  &__text {
    &:nth-child(2n + 1) {
      margin-right: 2.5em;
    }
  }
  @media screen and (min-width: 412px) and (max-width: 768px) {
    line-height: 2;
    &__title {
      font-size: 24px;
    }
  }
  @media screen and (max-width: 411px) {
    display: block;
    text-align: center;
    writing-mode: horizontal-tb;
    line-height: 2;
    &__title {
      font-size: 24px;
      &:first-child {
        margin-left: 0;
        margin-bottom: 1em;
      }
    }
    &__text {
      &:nth-child(2n + 1) {
        margin-right: 0;
        margin-top: 1.5em;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Organisms/Concept/index.vue